module.exports = __webpack_public_path__ + "static/media/66 - Michel Polnareff - Holidays.c47eff8f.mp3";